import { Icon, IconShape, arrows_clockwise, star } from '../../../components/Icon/Icon';
import { useTranslation } from '../../../i18n/i18n';
import './ProductSourceTiles.css';

/* a list the customer already has, as opposed to the search: offered only when it holds something */
export type ProductSource = 'favorites' | 'mostBought';

type ProductSourceTilesProps = {
	available: ProductSource[];
	selected: ProductSource | null;
	onSelect: (source: ProductSource | null) => void;
};

export const ProductSourceTiles = ({ available, selected, onSelect }: ProductSourceTilesProps): JSX.Element => {
	const t = { ...useTranslation().editOrder, favorite: useTranslation().favorite };

	const tiles: { source: ProductSource; label: string; icon: IconShape }[] = [
		{ source: 'favorites', label: t.favorite.favorites, icon: star },
		{ source: 'mostBought', label: t.mostBought, icon: arrows_clockwise },
	];

	return (
		<div className="product-source-tiles">
			{tiles
				.filter((tile) => available.includes(tile.source))
				.map((tile) => (
					<button
						key={tile.source}
						type="button"
						className={'product-source-tile' + (selected === tile.source ? ' selected' : '')}
						aria-pressed={selected === tile.source}
						// a second press on the same tile puts the search back, which is where the modal starts
						onClick={() => onSelect(selected === tile.source ? null : tile.source)}
					>
						<Icon shape={tile.icon} size={18} />
						<span>{tile.label}</span>
					</button>
				))}
		</div>
	);
};
